import MotorParseable from "./class.MotorParseable";

export default class HundredsChart extends MotorParseable {
	isClearButtonEnabled() {
		return this.clearButtonIsEnabled;
	}

	constructor(options) {
		super(options);
		this.clearButtonIsEnabled = false;
		this.startingValues = [];
	}

	getNewDriver() {
		return new Motors.Drivers.HundredsChartDriver();
	}

	getStartSignal() {
		let width = Number(this.model.width) || 1;
		let height = Number(this.model.height) || 1;
		let autoItems, autoPreselected, autoPrecrossed;
		let items, preselected, precrossed;
		if (this.model.auto) {
			//eventually rename the field to autoItems?
			autoItems = this.tryJSONParse(this.model.auto, (result) => {
				if (!_.isArray(result)) {
					return null;
				} else {
					let start = result[0];
					let incrementAmount = result[1];
					let length = width * height;
					result = [];
					for (let i = 0; i < length; i++) {
						let n = start + i * incrementAmount;
						result.push(n);
					}
					return result;
				}
			});
		}
		if (autoItems) {
			items = autoItems;
		} else {
			items = this.tryJSONParse(this.model.items, (result) => {
				if (!_.isArray(result)) {
					return Array(width * height).map((_) => "?");
				}
				return result;
			});
		}
		for (let i = 0; i < width * height; i++) {
			if (items[i] === undefined) {
				items[i] = "";
			}
		}
		let gridState = Object.assign({}, this.driverOutputs.gridState);
		let style = this.model.style.toLowerCase();
		if (["fill", "cross", "both"].indexOf(style) < 0) {
			style = "fill";
		}
		if (this.model.autoPreselected) {
			autoPreselected = this.tryJSONParse(
				this.model.autoPreselected,
				autoHelper
			);
		}
		if (autoPreselected) {
			preselected = autoPreselected;
		} else {
			preselected = this.tryJSONParse(this.model.preselected, (result) => {
				if (!_.isArray(result)) {
					return [];
				}
				return result;
			});
		}
		if (this.model.autoPrecrossed) {
			autoPrecrossed = this.tryJSONParse(this.model.autoPrecrossed, autoHelper);
		}
		if (autoPrecrossed) {
			precrossed = autoPrecrossed;
		} else {
			precrossed = this.tryJSONParse(this.model.precrossed, (result) => {
				if (!_.isArray(result)) {
					return [];
				}
				return result;
			});
		}
		let preselectedColor = this.model.preselectedColor;
		let selectedColor = this.model.selectedColor;
		let selectionLimit =
			this.model.selectionLimit < 0 ? Infinity : this.model.selectionLimit;
		let crossLimit =
			this.model.crossLimit < 0 ? Infinity : this.model.crossLimit;
		let unclickableIndices = this.tryJSONParse(
			this.model.unclickableIndices,
			(result) => {
				if (!_.isArray(result)) {
					return [];
				}
				return result;
			}
		);
		let isInteractive = this.model.isInteractive || this.isParsed;
		let cellWidthPx = this.model.cellWidthPx;
		let cellHeightPx = this.model.cellHeightPx;

		return {
			width,
			height,
			items,
			gridState,
			style,
			preselected,
			precrossed,
			preselectedColor,
			selectedColor,
			selectionLimit,
			crossLimit,
			unclickableIndices,
			isInteractive,
			cellWidthPx,
			cellHeightPx,
		};
	}

	getCachedResponseSignal(data) {
		return {
			gridState:
				// property name changed in Hundo motor... this is for backwards compatibility
				data.gridState || (data.state && data.state.gridState) || data.state,
		};
	}

	onRenderResponse($responseDiv) {
		this.clearButtonIsEnabled = !this.isResponseInitial();
		this.rerenderClearButton();

		const response = this.driverOutputs[this.answerKey] || [];
		this.setSubmittable(this.isResponseSubmittable(response));

		const preview = this.driverOutputs[this.previewKey] || [];
		if (this.previewKey === "noPreview") {
			return;
		} else if (preview.length === 0) {
			$responseDiv.html("<em>None selected.</em>");
		} else {
			$responseDiv.text(preview.join(", "));
		}
	}

	isResponseSubmittable(response) {
		if (response === undefined) {
			return false;
		} else if (Array.isArray(response)) {
			return response.length !== 0;
		} else {
			console.error("response has unexpected format");
		}
	}

	/**
	 * Hundreds Chart is set up like Column Connection, so that
	 * user responses are separate from seeded values.  So just
	 * need to check that the user output channels are both empty.
	 */
	isResponseInitial() {
		return (
			!this.isResponseSubmittable(this.driverOutputs["userSelectedIndices"]) &&
			!this.isResponseSubmittable(this.driverOutputs["userCrossedIndices"])
		);
	}
}

/**
 * A helper function for building auto-arrays for preselected and precrossed.
 * @param {Array<number>} autoInput An array with 3 numbers:
 *  	- the starting index,
 * 		- the amount to increment each index by,
 *  	- and the total number of indices.
 */
const autoHelper = (autoInput) => {
	if (!_.isArray(autoInput) || autoInput.length !== 3) {
		return null;
	} else {
		let start = autoInput[0];
		let incrementAmount = autoInput[1];
		let number = autoInput[2];
		let result = [];
		for (let i = 0; i < number; i++) {
			result.push(start + i * incrementAmount);
		}
		return result;
	}
};
